<template>
  <div class="on-print">
    <Toolbar />
    <v-container fluid grid-list-lg>
      <div v-if="!$vuetify.breakpoint.xsOnly" class="text-center text-h4">Welcome <span class="font-weight-bold">{{
          currentUser.name
      }}</span></div>
      <div v-else class="text-center font-weight-light text-h6">Welcome <span class="font-weight-bold">{{
          currentUser.name
      }}</span></div>
      
      <v-layout row justify-center>
        <v-flex shrink>
          <v-chip-group v-model="selectedClassRoom" active-class="primary--text"
            v-if="Teacher && Teacher.ClassRoomTeachers">
            <v-chip :value="room" v-for="(room, index) in Teacher.ClassRoomTeachers" :key="index">
              {{ room.ClassRoom.name }}
            </v-chip>
          </v-chip-group>
        </v-flex>
      </v-layout>

      <div v-if="isLoading">
        <div class="text-center">
          <v-progress-circular :size="70" :width="7" color="purple" indeterminate></v-progress-circular>
          <div class="mt-3">Loading...</div>
          <div>Please standby waiting admin approval</div>
        </div>
      </div>

      <div v-else>
        <div class="text-center" v-if="Students.length">You have <span class="font-weight-bold">{{
            Students.length
        }}</span>
          <span v-if="Students.length > 1"> students</span>
          <span v-else> student</span>
        </div>


        <v-row class="mt-2" v-if="Teacher">
          <v-col cols="12">
            <v-card outlined class="rounded-lg">
              <v-card-text>
                <v-layout row wrap>
                  <v-flex class="text-h6">Students</v-flex>
                  <v-spacer></v-spacer>
                  <v-flex shrink v-if="Students.length">
                    <v-btn elevation="0" small @click="addStudent" color="success">Add</v-btn>
                  </v-flex>
                </v-layout>
                <v-list v-if="Students.length" class="view-container" :dense="$vuetify.breakpoint.xsOnly">
                  <template v-for="(item, index) in Students">

                    <v-list-item v-if="item.Student" @click="openStudent(item)" :key="item.Student.fullName">
                      <v-list-item-content>
                        <v-list-item-title class="font-weight-bold text-capitalize" v-if="item.Student">{{ item.Student.fullName }}
                        </v-list-item-title>

                        <v-list-item-subtitle v-if="item.Student.Customer && item.Student.Customer.fatherName"
                          class="text-capitalize">{{ item.Student.Customer.fatherName }}
                        </v-list-item-subtitle>
                        <!-- <v-list-item-subtitle v-if="item.femaleStudentLeads !== 0">{{ item.femaleStudentLeads }} - Female
                  </v-list-item-subtitle> -->


                      </v-list-item-content>
                      <v-list-item-action>

                        <!-- <v-list-item-title v-if="item.Student.Customer && item.Student.Customer.phoneNumber">{{
                            item.Student.Customer.phoneNumber | USPhoneNumber
                        }}</v-list-item-title> -->


                        <v-progress-circular :size="35" :width="3" :value="item.per" color="teal">
                          <span class="caption">{{ item.per }}</span>
                        </v-progress-circular>
                      </v-list-item-action>
                    </v-list-item>

                    <v-divider v-if="index < Students.length - 1" :key="index"></v-divider>
                  </template>

                </v-list>
                <v-card flat v-else class="view-container">
                  <v-card-text>
                    <div class="text-center">
                      You have no student assign to you, press here to add some to your class

                    </div>
                    <div class="text-center mt-6">
                      <v-btn @click="addStudent" color="success">Add Student</v-btn>
                    </div>

                  </v-card-text>
                </v-card>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </div>




    </v-container>
    <BottomNavigation />
  </div>

</template>
<script>


import teacherService from "@/modules/Teacher/service.js";
import classRoomService from "@/modules/ClassRoom/service.js";
import attService from '@/modules/Attendance/service.js'
import Toolbar from "@/modules/Layout/components/Toolbar.vue";
import BottomNavigation from "@/modules/Layout/components/BottomNavigation.vue";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "teacher-home",
  data() {
    return {
      isLoading: true,
      AllStudents: null,
      Students: [],
      selectedStudent: null,
      openDialog: null,
      attendanceDialog: null,
      Attendance: [],
    }
  },
  components: {
    // Attendance,
    BottomNavigation,
    Toolbar,
  },
  async created() {
    document.title = "taleem - Home";
    // console.log('created got call')
    this.loadData()
  },
  watch: {
    currentUser() {
      this.loadData()
    },
    async selectedClassRoom(val) {
      if (val) {
        await this.getAttendance()
        await this.getStudent()
      }
    },
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus", "getClassRoom"]),
    ...mapGetters("teacherLayout", ["getClassRoom", "getTeacherStore"]),
    selectedClassRoom: {
      get() {
        return this.getClassRoom
      },
      set(val) {
        this.setClassRoom(val)
      }
    },
    Teacher: {
      get() {
        return this.getTeacherStore
      },
      set(val) {
        this.setTeacher(val)
      }
    },
  },
  methods: {
    ...mapActions("teacherLayout", ['setClassRoom', 'setTeacher']),
    async loadData() {
      if (this.currentUser && this.currentUser.Teacher) {
        await this.getTeacher()
        if (this.Teacher.ClassRoomTeachers.length) {
          if (!this.selectedClassRoom) {
            this.selectedClassRoom = this.Teacher.ClassRoomTeachers[0]
          } else {
            await this.getAttendance()
            await this.getStudent()
          }
        }
      }

    },
    setAttendance() {
      // console.log('return')
      this.Attendance.map(async (row) => {
        row.per = ((row.totalPresentAttendance + row.totalLateAttendance + row.totalLeaveAttendance) / row.totalAttendance) * 100
        await Promise.all(
          this.Students.map(student => {
            // console.log('found i4t', student.StudentId, row.id)
            if (student.StudentId === row.id) {
              // console.log('found i4t', row)
              if (isNaN(parseInt(row.per))) {
                student.per = 0
              } else {
                student.per = parseInt(row.per)
              }
              student.totalAttendance = row.totalAttendance
              student.totalPresentAttendance = row.totalPresentAttendance
              student.totalLateAttendance = row.totalLateAttendance
              student.totalLeaveAttendance = row.totalLeaveAttendance
              student.totalAbsentAttendance = row.totalAbsentAttendance
            }
          }))
      })
      // console.log('Students', this.Students)
    },
    getAttendance() {
      const where = {
        start: this.$moment()
          .startOf("month")
          .toISOString(),
        end: this.$moment()
          .endOf("month")
          .toISOString(),
        ClassRoomId: this.selectedClassRoom.ClassRoomId
      }
      
      return attService.attendanceInfo(where)
        .then(response => {
          // console.log('response attendanceInfo', response)

          return this.Attendance = response.data

        })
    },
    getStudent() {
      this.isLoading = true
      classRoomService.getAssignStudentList({ ClassRoomId: this.selectedClassRoom.ClassRoomId, includeClassStudent: true })
        .then(response => {
          // console.log('response Students', response)
          this.Students = response.data
          this.setAttendance()
          this.isLoading = false
        })
    },

    studentRemove() {
      this.openDialog = !this.openDialog
      this.getTeacher()
    },
    addStudent() {
      this.$router.push({ name: `add-student-to-class-room`, params: { teacher: this.Teacher, selectedClassRoom: this.selectedClassRoom, students: this.Students } });

      // this.dialog = !this.dialog
    },
    openStudent(item) {
      // console.log('itemitem', item)
      this.$router.push({ name: `student-profile`, params: { student: item, selectedClassRoom: this.selectedClassRoom } });

    },
    getTeacher() {
      return teacherService.getById(this.currentUser.Teacher.id).then((response) => {
        this.Teacher = response.data;
        // console.log('response', response)
        // this.selectedClassRoom = this.Teacher.ClassRoomTeachers[0]
        this.isLoading = false
        return response;
      });
    },
  }
};
</script>
<style scoped>
.view-container {
  height: calc(100vh - 365px);
  width: 100%;
  overflow: auto;
}
</style>
